import { useVibrationCriteria } from "@/api/vibration-criteria-query";

export default defineComponent({
	name: "AlertConditionDescription",
	props: {
		criteria: {
			type: [String, null],
		},
	},
	setup(props) {
		const vibrationCriteriaId = computed(() => props.criteria || "");

		const { data: vibrationCriteria } = useVibrationCriteria(vibrationCriteriaId);
		function generateVibrationEventName() {
			if (!vibrationCriteriaId.value || !vibrationCriteria.value) {
				return "";
			}
			return vibrationCriteria.value.name;
		}

		const description = computed(() => {
			return generateVibrationEventName() || "-";
		});
		return () => <div>{description.value}</div>;
	},
});
